/* Closure trail — a role-scoped incident picker (left) and the chosen report's trail (right),
 * in the shell's language (13-15). The picker is one white sheet of rows divided by --line, the
 * mock's rail idiom, rather than a stack of boxed cards; the chosen row takes the lavender
 * selected surface with a purple-light edge (identity, never a purple fill). */

/* The page-head lede (mock .pagehead p). */
.intro {
  margin: 8px 0 28px;
  max-width: 66ch;
  font-size: 15px;
  color: var(--gray);
}

/* ── Two-pane layout (picker | trail). Collapses to one column on narrow. ── */
.layout {
  display: grid;
  grid-template-columns: minmax(16rem, 20rem) minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}

@media (max-width: 48rem) {
  .layout {
    grid-template-columns: 1fr;
  }
}

/* ── Picker ── */
.picker {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

/* The mock's serif section heading (.rail h3). */
.pickerHeading {
  margin: 0;
  font-family: var(--serif);
  font-weight: 500;
  font-size: 20px;
  line-height: 1.2;
  color: var(--purple-dark);
}

.pickerList {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 70vh;
  overflow-y: auto;
  border: 1px solid var(--line);
  border-radius: 18px;
  background-color: var(--white);
  box-shadow: var(--shadow-sm);
}

.pickerList > li + li {
  border-top: 1px solid var(--line);
}

.pickerItem {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  text-align: left;
  padding: 12px 16px;
  background: none;
  border: none;
  border-radius: 0;
  cursor: pointer;
  font: inherit;
  transition: background-color 0.2s;
}

.pickerItem:hover {
  background-color: var(--lavender-light);
}

.pickerItem:focus-visible {
  outline: 2px solid var(--purple);
  outline-offset: -2px;
}

.pickerItemActive,
.pickerItemActive:hover {
  background-color: var(--lavender);
  box-shadow: inset 3px 0 0 var(--purple-light);
}

.pickerRef {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--charcoal);
  font-variant-numeric: tabular-nums;
}

.pickerItemActive .pickerRef {
  color: var(--purple-dark);
}

.pickerTitle {
  font-size: 13.5px;
  line-height: 1.4;
  color: var(--gray);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pickerLoading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 0;
  color: var(--gray);
  font-size: 14px;
}

.pickerError {
  padding: 12px 14px;
  border-radius: 12px;
  background-color: var(--red-soft);
  color: var(--red-dark);
  font-size: 14px;
}

.pickerEmpty {
  text-align: left;
}

.pickerEmptyTitle {
  margin: 0 0 4px;
  font-family: var(--serif);
  font-weight: 400;
  font-size: 20px;
  line-height: 1.25;
  color: var(--purple-dark);
}

.pickerEmptyBody {
  margin: 0;
  font-size: 13.5px;
  color: var(--gray);
}

/* ── Trail pane ── */
.trailPane {
  min-width: 0;
}

/* Before a pick: the mock's .empty-state. */
.prompt {
  padding: 56px 24px;
  text-align: center;
}

.promptTitle {
  margin: 0 0 6px;
  font-family: var(--serif);
  font-weight: 400;
  font-size: 26px;
  line-height: 1.2;
  color: var(--purple-dark);
}

.promptBody {
  margin: 0 auto;
  max-width: 52ch;
  font-size: 14.5px;
  color: var(--gray);
}
